import React, { useState, useEffect } from "react";
import Mens from "./Mens";
import Pagination from "./Pagination";
import { toast } from "react-toastify";
import axios from "axios";
import { motion } from "framer-motion";
import { MenuItem, Select } from "@mui/material";

const MensWithPagination = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
   
      getMens();
    
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  const getMens = async () => {
    try {
      const response = await axios.get(
        `https://winterstore-backend.onrender.com/product/idealfor/Men`
      );
      if (response.status === 200) {
        setItems(response.data);
        setIsLoading(false);
      }
    } catch (error) {
      toast.error("Server Error");
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  return (
    <motion.div
      initial={{ x: "-100vw" }}
      animate={{ x: 0 }}
      transition={{ duration: 2, type: "spring" }}
    >
      <Mens currentPage={currentPage} itemsPerPage={itemsPerPage} />
      {isMobile ? (
        <div className="mt-3 col-12">
          <Select
            className="form-select form-select-sm mb-2"
            aria-label="Items Per Page"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
          >
            <MenuItem value="4">4 per page</MenuItem>
            <MenuItem value="8">8 per page</MenuItem>
            <MenuItem value="12">12 per page</MenuItem>
            <MenuItem value="16">16 per page</MenuItem>
          </Select>
          <Select
            className="form-select form-select-sm"
            aria-label="Page Number"
            value={currentPage}
            onChange={(e) => handlePageChange(parseInt(e.target.value))}
          >
            {Array.from(
              { length: Math.ceil(items.length / itemsPerPage) },
              (_, i) => (
                <MenuItem key={i} value={i + 1}>
                  Page {i + 1}
                </MenuItem>
              )
            )}
          </Select>
        </div>
      ) : (
        <Pagination
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          totalItems={items.length}
          onPageChange={handlePageChange}
        />
      )}
    </motion.div>
  );
};

export default MensWithPagination;

